<template>
  <div class="info-row" :class="{ 'info-row--stacked': stacked }">
    <div class="info-row__label">{{ label }}</div>
    <div class="info-row__value">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: "InfoRow",
  props: {
    label: {
      type: String,
      required: true,
    },
    // для длинных значений (адрес, комментарий) — значение под лейблом на всю ширину
    stacked: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.info-row {
  display: flex;
  gap: 1.5rem;
  align-items: baseline;
  padding: 0.8rem 0;
  border-bottom: 1px solid var(--light-theme-gray-color);

  &:last-child {
    border-bottom: none;
  }

  &__label {
    flex: 0 0 38%;
    max-width: 38%;
    color: var(--secondary-gray);
    font-weight: 400;
  }

  &__value {
    flex: 1 1 auto;
    color: var(--font-dark-color);
    font-weight: 500;
    word-break: break-word;
  }

  &--stacked {
    flex-direction: column;
    gap: 0.35rem;

    .info-row__label {
      flex-basis: auto;
      max-width: 100%;
    }

    .info-row__value {
      font-weight: 400;
      line-height: 1.5;
    }
  }

  @media (max-width: 575px) {
    flex-direction: column;
    gap: 0.2rem;

    .info-row__label {
      flex-basis: auto;
      max-width: 100%;
    }
  }
}
</style>
